module.exports = __webpack_public_path__ + "img/电梯动画12.25e4e89e.png";